<template>
  <span class="has-tooltip" data-cy="tooltip-factory-code">
    <backstage-icon name="black-info" />
    <span class="tooltip" :style="getImage"></span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import BackstageIcon from './BackstageIcon.vue';

const props = defineProps<{
  imageLocation: string;
}>();

const getImage = computed(() => {
  return { 'background-image': `url(${props.imageLocation})` };
});
</script>

<style lang="scss" scoped>
.has-tooltip {
  position: relative;
  cursor: pointer;

  &:hover {
    .tooltip {
      display: block;
    }
  }

  .tooltip {
    position: absolute;
    padding: 0;
    z-index: 9;
    top: 50%;
    left: 100%;
    display: none;
    width: 26rem;
    height: 26rem;
    transform: translateY(-10%);
    box-shadow: 0 1.25rem 2.5rem -0.875rem rgba(0, 0, 0, 0.25);
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: var(--white-color);
  }
}
</style>
